const x = {
  crs: {
    type: "name",
    properties: {
      name: "urn:ogc:def:crs:EPSG::25832",
    },
  },
  type: "Feature",
  selected: false,
};
export default x;
